@if (vm$ | async; as vm) {
  <div class="container-fluid">
    <div class="row justify-center">
      <div class="col md:col-6">
        <mat-card>
          <mat-card-header>
            <mat-card-title>{{ 'catalog.settings.title' | transloco }}</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <mat-divider class="my-3"></mat-divider>
            <cat-search-settings
              (formSettingToggle)="searchRepository.toggleFormSetting($event)"
              (logicalOperatorChange)="castorConfigRepository.setActiveLogicalOperator($event)"
              (searchFormModeChange)="searchRepository.setSearchFormMode($event)"
              [formSettings]="vm.formSettings"
              [logicalOperator]="vm.activeLogicalOperator"
              [searchFormMode]="vm.searchFormMode"
            ></cat-search-settings>
            <mat-divider class="my-3"></mat-divider>
            <cat-result-settings
              (tabsLockedChange)="searchRepository.setTabsLocked($event)"
              [tabsLocked]="vm.searchResultTabsLocked"
            ></cat-result-settings>
            <mat-divider class="my-3"></mat-divider>
            <cat-detail-settings
              (compactHeaderChange)="detailRepository.setCompactHeader($event)"
              (tabsLockedChange)="detailRepository.setTabsLocked($event)"
              [compactHeader]="vm.detailCompactHeader"
              [tabsLocked]="vm.detailTabsLocked"
            ></cat-detail-settings>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
}
